import React from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import landing from './media/final1.mp4';
import './App.css';


import Navbar from './Navbar';
import Footer from './footer';
import StoreLocator from './StoreLocator';
import MeetTheTeam from './MeetTheTeam';

import ReviewsScroll from './ReviewsScroll';
import OutstandingResults from './OutstandingResults';
import TechSection from './TechSection';
import PrecisionSection from './PrecisionSection';

import BookAppointment from './BookAppointment';

import AdminPage from './AdminPage';
import AdminLogin from './AdminLogin';
import PatientStories from './PatientStories';
import ExpertiseSection from './ExpertiseSection';
import TreatementsSection from './TreatementsSection';
import LandingHero from './LandingHero';

import ScrollingGallery from './ScrollingGallery';
import ProtectedRoute from "./ProtectedRoute";
import FAQSection from './FAQSection';
import WhatsappButton from "./WhatsappButton";
import CareersPage from './CareersPage';
import FindUs from './FindUs';

function HomePage() {
  const navigate = useNavigate();

  return (
    <main>

 


      <Navbar />

      <div className="landing">
       

        <video autoPlay loop muted playsInline className="landing-video">
          <source src={landing} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="landing-overlay">
          <h1>PrimeMax | Best Dental Clinic in Guwahati</h1>
          <p>Your dental journey begins here.</p>

          {/* ✅ Book Now Button */}
           <button
            className="landing-book-btn"
            onClick={() => navigate("/book")}
          >
            Book Now
          </button>
        </div>
      </div> 

      {/* <ContactMarquee /> */}
      {/* <BenefitsScroll /> */}
      <LandingHero />
      <ReviewsScroll />
      <TreatementsSection />
      <OutstandingResults />
      <TechSection />
      <PrecisionSection />
      <PatientStories />
      <ExpertiseSection />
      
      <ScrollingGallery />
      <MeetTheTeam />
      <StoreLocator />
      <FindUs />
      <FAQSection />
      <Footer />
      <WhatsappButton />
    </main>
  );
}

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/book" element={<BookAppointment />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/faq" element={<FAQSection />} />
        <Route path="/store" element={<StoreLocator />} />

        {/* <Route path="/admin" element={<AdminPage />} /> */}
         <Route path="/admin-login" element={<AdminLogin />} />

         <Route
    path="/admin"
    element={
      <ProtectedRoute>
        <AdminPage />
      </ProtectedRoute>
    }
  />
        
      </Routes>
    </div>
  );
}

export default App;
